import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/searchPage/actionTypes';

import { resetEditFilters } from './utils';

export default function* listenResetEditFilters() {
  yield takeEvery(actionTypes.RESET_EDIT_FILTERS, resetEditFilters);
}
